module.exports = __webpack_public_path__ + "img/web_active.ce447f0b.svg";